<template>
  <el-dialog :title="title" @close="$emit('update:visible', false)">
    <div class="view">
      <div class="title">
        <i class="goback el-icon-arrow-left" @click="goback"></i>
        <!-- {{titleinfo}} -->
      </div>
      <div class="content">
        <div class="set_flexwrap">
          <div class="flex_wrap">
            <el-form
              ref="form"
              :rules="rules"
              :model="formdata"
              label-width="120px"
            >
              <div class="form_splititem">配置内容</div>
              <!-- <button @click.stop="handlePsdFile">343434</button> -->
              <div class="outer_box" v-if="false">
                <!-- 因为旋转是在中心点旋转的,而放大缩小是在左上角 -->
                <!-- 所以给图片的父元素加上放大缩小 -->
                <!-- 给图片加上旋转 -->
                <div
                  class="img_box"
                  :style="{
                    transform: 'scale(' + multiples + ')',
                    transformOrigin: 'top left',
                  }"
                >
                  <!-- <img :src="imgSrc" 
                      alt="" 
                      :style="{transform:'rotateZ('+deg+'deg)'}"  v-drag>     -->
                </div>
                <!-- 点击时旋转90度 -->
                <button @click="magnify">放大</button>
                <!-- 缩小0.25 -->
                <button @click="shrink">缩小</button>
                <!-- 放大0.25 -->
                <button @click="rotate">旋转</button>
              </div>

              <!-- {{ JSON.stringify(customArr) +'------------------------------------'}} -->

              <div v-for="(item, index) in customArr">
                <div>
                  <canvas
                    :id="'canvas' + index"
                    :width="item.width"
                    :height="item.height"
                  ></canvas>
                  <div style="display: flex; margin-top: 20px">
                    <el-upload
                      class="addicon"
                      :action="uploadurl"
                      :data="data_"
                      :show-file-list="false"
                      :limit="3"
                      multiple
                      :on-change="handlePsdFile"
                      :on-success="handleItemSuccess"
                      :before-upload="beforeCanvasItemUpload"
                    >
                      <el-button @click="bindUploadItem(item, index)"
                        >上传用户图片</el-button
                      >
                    </el-upload>
                    <!-- <el-button @click="bindSendToLayer(index,'front')">移至顶层</el-button>
                        <el-button @click="bindSendToLayer(index,'bottom')">移至底层</el-button>
                        <el-button @click="bindDeleteImage">删除图层</el-button>
                        <el-upload
                        class="addicon"
                        :action="uploadurl"
                        :data="data_"
                        :show-file-list="false"
                        :limit="3"
                        multiple
                        :on-change="handlePsdFile1"
                        :on-success="handleChangeSuccess"
                        :before-upload="beforeCanvasItemUpload1"
                        >
                          <el-button>更换图片</el-button>
                      </el-upload> -->
                  </div>
                </div>
              </div>
              <el-form-item label="上传模版" v-if="customArr.length == 0">
                <el-upload
                  class="addicon"
                  :action="uploadurl"
                  :data="data_"
                  :show-file-list="false"
                  :limit="3"
                  multiple
                  :on-change="handlePsdFile"
                  :on-success="handlevideoSuccess"
                  :before-upload="beforePsdUpload"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div slot="tip" class="el-upload__tip">点击上传模板图片1</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <!-- <el-button type="primary" @click="savegood('form')" size="small" v-if="goodsType==2">复制新商品</el-button> -->
                <el-button type="primary" @click="savegood('form')" size="small"
                  >保存</el-button
                >
                <el-button @click="goback" size="small">取消</el-button>
              </el-form-item>
              <a href="goShowImg" target="_blank"></a>
            </el-form>
          </div>
        </div>
      </div>
      <corpper
        :visible.sync="corppervisible"
        v-if="corppervisible"
        @imgAddBack="imgAddBack"
        :imgSize="imgSize"
      ></corpper>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleTemplate = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import uploaddrag from "@/components/uploaddrag.vue";
import corpper from "@/components/dialog/corpper.vue";
import draggable from "vuedraggable";
import { Rect, Circle } from "fabric";

import {
  goodtype,
  issale,
  ishot,
  isrecommend,
  ischeap,
  isnew,
  logisticsset,
  commset,
  commtype,
  isattr,
  ispay,
  showtype,
  shippingset,
  pagination,
} from "@/util/util.js";
import customSpecificationDialog from "@/components/dialog/customSpecificationDialog.vue";
import goodsCustomMakeListDialogVue from "@/components/dialog/goodsCustomMakeListDialog.vue";
import api from "@/api.js";
export default {
  name: "goodsSelectSpecificationDialog",
  props: [
    "visible",
    "templateId",
    "templateDetailId",
    "templateType",
    "dialogVisibleTemplate",
  ],
  components: {
    uploaddrag,
    corpper,
    draggable,
  },
  watch: {
    visible() {
      console.log(this.visible, "this.visiblethis.visible");
      this.dialogVisibleTemplate = this.visible;
    },
  },
  data() {
    return {
      canvasOptions: {
        width: 600,
        height: 400,
        centerMode: true,
        cursorOverfill: "transparent",
        backgroundColor: "#f5f5f5",
        objectCaching: false,
        defaultCursor: "default",
        selectionStyle: "box",
        borderScaleFactor: 1,
        objects: [
          {
            type: "rect",
            left: 100,
            top: 100,
            width: 50,
            height: 50,
            fill: "red",
          },
          {
            type: "circle",
            left: 200,
            top: 200,
            radius: 50,
            fill: "blue",
          },
        ],
      },
      data_: { token: sessionStorage.getItem("token") },
      imgSize: 0,
      corppervisible: false,
      currentindex: 0,
      titleinfo: "模板",
      title: "定制模板1",
      uploadurl: api.uploadTokenImg,
      uploadvideourl: api.uploadTokenVideo,
      goodtype: goodtype,
      issale: issale,
      ishot: ishot,
      isrecommend: isrecommend,
      ischeap: ischeap,
      isnew: isnew,
      logisticsset: logisticsset,
      commset: commset,
      commtype: commtype,
      isattr: isattr,
      ispay: ispay,
      showtype: showtype,
      shippingset: shippingset,
      formdata: {
        type: 0,
        goods_name: "",
        cat_id: [],
        cat_label: [],
        album: [],
        video: "",
        goods_detail: [],
        order_desc: "",
        is_pay: 0,
        is_attr: 0,
        unit: "",
        cost: "",
        shop_price: "",
        goods_number: "",
        comm_type: 0,
        commission: "",
        comm_set: 0,
        comm_outside: 50,
        outside: "",
        comm_inside: 50,
        inside: "",
        logistics_set: 0,
        shipping_set: 0,
        shipping_fee: "",
        fre_id: "",
        shipping_name: "",
        shipping_phone: "",
        is_sale: 0,
        is_hot: 0,
        is_recommend: 0,
        is_cheap: 0,
        is_new: 0,
        show_type: "",
        show_price: "",
        reference: "",
        reference_price: "1万-10万",
        reference1: "参考价格",
        reference2: "价格面议",
        attr_cate: "",
        goods_brief: "",
        goods_desc: "",
        points: "",
        false_sales: "", // 初始化虚拟销量
      },
      cateoptions: [],
      freoptions: [],
      attrcateoptions: [],
      imageUrl: "",
      checkattrList: [],
      attrinfo: [],
      tablehead: [],
      attr_price: "",
      attr_number: "",
      attr_points: "",
      attrtable: [],
      id: "",
      ispayshow: false,
      lock: true,
      attremptycount: 0,
      defaultProps: {
        value: "id",
        label: "name",
        children: "child",
      },
      rules: {
        goods_name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        album: [
          { required: true, message: "请上传产品图片", trigger: "change" },
        ],
        goods_detail: [
          { required: true, message: "请上传产品详情图片", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入销售单位", trigger: "blur" }],
        goods_number: [
          { required: true, message: "请输入库存", trigger: "blur" },
        ],
        attr_cate: [
          { required: true, message: "请选择商品类目", trigger: "change" },
        ],
        shop_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      goodsType: null,
      drawer: false, // 是否显示表单列表
      formList: [], // 表单列表
      form_id: "", // 选中的表单
      form_name: "", // 表单名称
      form_btn: "", // 按钮名称
      loading: true,
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total,
      },
      menbanArr: [],
      imgSrc:
        "https://publish-pic-cpu.baidu.com/cf60d547-a35c-4e77-8ef3-30d0e5b0e48b.jpeg@q_90,w_450",
      deg: 0,
      multiples: 1,
      customArr: [],
      isDragging: false,
      userObjectArr: [],
    };
  },
  created() {
    console.log("create");
    return;
    //  this.ispaysetshow();
    this.id = this.templateId;
    this.detailId = this.templateDetailId;
    this.goodsType = this.templateType;
    if (this.detailId) {
      let titleinfo = "编辑商品";
      if (this.goodsType === 2) {
        titleinfo = "复制商品";
      }
      this.titleinfo = titleinfo;
      // 查询详情
      this.uploadItemImgIndex = 0;
      this.querydetail();
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  methods: {
    getImg: function () {
      this.imgcoordinate = [];
      let items = this.canvasObj.getObjects();
      console.log(items, "itemsitems");
      items.forEach((item, index) => {
        let itemcoord = {
          floorIndex: index,
          tl: {
            x: item.aCoords.tl.x,
            y: item.aCoords.tl.y,
          },
          tr: {
            x: item.aCoords.tr.x,
            y: item.aCoords.tr.y,
          },
          bl: {
            x: item.aCoords.bl.x,
            y: item.aCoords.bl.y,
          },
          br: {
            x: item.aCoords.br.x,
            y: item.aCoords.br.y,
          },
        };
        this.imgcoordinate.push(itemcoord);
      });
    },
    draggEndSort() {
      this.isDragging = false;
    },
    // 放大
    magnify() {
      if (this.multiples >= 3) {
        return;
      }
      this.multiples += 0.25;
    },
    // 缩小
    shrink() {
      if (this.multiples <= 0.5) {
        return;
      }
      this.multiples -= 0.25;
    },
    // 旋转
    rotate() {
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
    },

    // 查询编辑详情
    querydetail() {
      let that = this;
      let params = {
        id: this.detailId,
      };
      this.loadingStatus = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor",
      });
      let apiHttp_ = api.custom_detail;
      this.axios
        .post(apiHttp_, params)
        .then((response) => {
          if (response.data.code == 0) {
            console.log("data", response.data.info.pics_set, response.data);
            that.handlevideoSuccess(
              { code: 0, path: response.data.info.background },
              response.data.info.pics_set
            );
          } else {
          }
        })
        .catch((response) => {});
    },

    imgAddBack(option) {
      this.formdata.album.push(option);
    },

    bindUploadItem(item, index) {
      //把上传用户图片的index存起来
      this.uploadItemImgIndex = index;
    },
    handleChangeSuccess(res, file) {
      if (res.code === 0) {
        this.bindChangeImage(res.path);
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    async detailhandleItemSuccess(res, detailData) {
      let that = this;
      return new Promise(async (resolve, reject) => {
        console.log(res, "res");
        if (res.code === 0) {
          // this.formdata.video = res.path;
          let uploadItem = that.customArr[that.uploadItemImgIndex].userImg;
          let customArr = that.customArr;
          //获取图片信息
          let imgInfo = await that.getImgInfo(res.path);
          if (uploadItem && uploadItem.length > 0) {
            customArr[that.uploadItemImgIndex].userImg.push({
              imgUrl: res.path,
              top: 0,
              left: 0,
              naturalWidth: imgInfo.naturalWidth,
              naturalHeight: imgInfo.naturalHeight,
              width: 200,
              height: (200 * imgInfo.naturalHeight) / imgInfo.naturalWidth,
            });
          } else {
            customArr[that.uploadItemImgIndex].userImg = [
              {
                imgUrl: res.path,
                top: 0,
                left: 0,
                naturalWidth: imgInfo.naturalWidth,
                naturalHeight: imgInfo.naturalHeight,
                width: 200,
                height: (200 * imgInfo.naturalHeight) / imgInfo.naturalWidth,
              },
            ];
          }
          that.customArr = customArr;
          that.$set(
            that.customArr,
            that.uploadItemImgIndex,
            customArr[that.uploadItemImgIndex]
          );
          that.canvasItemAddImg(that.uploadItemImgIndex, res.path, detailData);
          console.log(that.customArr, "that.customArr");
          resolve(true);
        } else {
          that.$message.error(res.msg);
          reject(false);
        }
        that.loadingStatus.close();
      });
    },
    async handleItemSuccess(res, detailData) {
      let that = this;
      console.log(res, "res");
      if (res.code === 0) {
        // this.formdata.video = res.path;
        let uploadItem = that.customArr[that.uploadItemImgIndex].userImg;
        let customArr = that.customArr;
        //获取图片信息
        let imgInfo = await that.getImgInfo(res.path);
        if (uploadItem && uploadItem.length > 0) {
          customArr[that.uploadItemImgIndex].userImg.push({
            imgUrl: res.path,
            top: 0,
            left: 0,
            naturalWidth: imgInfo.naturalWidth,
            naturalHeight: imgInfo.naturalHeight,
            width: 200,
            height: (200 * imgInfo.naturalHeight) / imgInfo.naturalWidth,
          });
        } else {
          customArr[that.uploadItemImgIndex].userImg = [
            {
              imgUrl: res.path,
              top: 0,
              left: 0,
              naturalWidth: imgInfo.naturalWidth,
              naturalHeight: imgInfo.naturalHeight,
              width: 200,
              height: (200 * imgInfo.naturalHeight) / imgInfo.naturalWidth,
            },
          ];
        }
        that.customArr = customArr;
        that.$set(
          that.customArr,
          that.uploadItemImgIndex,
          customArr[that.uploadItemImgIndex]
        );
        that.canvasItemAddImg(that.uploadItemImgIndex, res.path);
        console.log(that.customArr, "that.customArr");
      } else {
        that.$message.error(res.msg);
      }
      that.loadingStatus.close();
    },
    bindSendToLayer(index, type) {
      console.log(this.userObjectArr, "this.userObjectArrthis.userObjectArr");
      let canvasObj = this["canvasObj0"];
      let t = canvasObj.getActiveObject();
      console.log(
        this.userObjectArr,
        "this.userObjectArrthis.userObjectArr",
        t
      );
      if (type == "front") {
        // t.bringToFront()
        // canvasObj.bringToFront(t)
        // canvasObj.bringForward(t)
        // canvasObj.setZoom(10)
        this.userObjectArr[0].bringToFront();
        // t.set({zIndex:100})
      } else {
        // t.sendToBack()
        // canvasObj.sendBackwards(t)
        // canvasObj.sendToBack(t)
        // canvasObj.setZoom(1)
        this.userObjectArr[0].sendToBack();
        // t.set({zIndex:1})
      }
      canvasObj.renderAll();
    },
    bindChangeImage(path) {
      let canvasObj = this["canvasObj0"];
      let t = canvasObj.getActiveObject();
      t.setSrc(path, (oImg) => {
        canvasObj.add(oImg);
        canvasObj.renderAll();
      });
    },
    bindDeleteImage() {
      let canvasObj = this["canvasObj0"];
      let t = canvasObj.getActiveObject();
      canvasObj.remove(t);
      canvasObj.renderAll();
    },
    async handlevideoSuccess(res, detailData) {
      let that = this;
      console.log(res, "res");
      if (res.code === 0) {
        // this.formdata.video = res.path;
        let imgInfo = await this.getImgInfo(res.path);
        let cItem = {
          bgImg: res.path,
          naturalWidth: imgInfo.naturalWidth,
          naturalHeight: imgInfo.naturalHeight,
          width: 600,
          height: (600 * imgInfo.naturalHeight) / imgInfo.naturalWidth,
        };
        this.customArr.push(cItem);
        console.log(this.customArr, "this.customArr");
      } else {
        this.$message.error(res.msg);
      }

      this.loadingStatus.close();
      setTimeout(() => {
        that.setNewCanvas();
      });
      if (detailData) {
        that.detailDataSet(detailData);
      }
    },
    async detailDataSet(detailData) {
      let that = this;
      for (let i = 0; i < detailData.length; i++) {
        that.loadingStatus = that.$loading({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.4)",
          customClass: "fontColor",
        });
        let res = await that.detailhandleItemSuccess(
          { code: 0, path: detailData[i].img },
          detailData[i]
        );
      }
    },
    setNewCanvas() {
      let that = this;
      let customArr = this.customArr;
      customArr.forEach((item, index) => {
        if (!this["canvasObj" + index]) {
          that.newCanvas(index, item.bgImg);
        }
      });
    },
    newCanvas(index, bgImg) {
      let canvasObj = new fabric.Canvas("canvas" + index);
      canvasObj.on("mouse:down", this.canvasOnMouseDown());
      let imageUrl = bgImg;
      // 创建一个图片对象
      var bgimgObject = new fabric.Image.fromURL(imageUrl, function (oImg) {
        console.log(oImg, oImg.height, "oImgoImgoImg");
        // 在画布上添加图片
        canvasObj.add(oImg);

        // 调整图片大小和位置
        var maxWidth = 600; // 图片最大宽度限制
        var maxHeight = 100; // 图片最大高度限制

        var imgWidth = oImg.width; // 图片实际宽度
        var imgHeight = oImg.height; // 图片实际高度
        oImg.set({
          left: 0, // 图片相对画布的左侧距离
          top: 0, // 图片相对画布的顶部距离
          opacity: 1, // 图片透明度
          // angle: 30,
          // 这里可以通过scaleX和scaleY来设置图片绘制后的大小，这里为原来大小的一半
          scaleX: maxWidth / oImg.width,
          scaleY: maxWidth / oImg.width,
          hasControls: false,
          lockMovementY: true,
          lockMovementX: true,
          backgroundColor: "#b2b3b3",
        });
        // 更新画布
        canvasObj.renderAll();
        console.log(bgimgObject, "bgimgObjectbgimgObject");
        // bgimgObject.setControlsVisibility({
        //   tl:false,
        //   tr:false,
        //   br:false,
        //   mt:false,
        //   mr:false,
        //   mtr:false,
        // })
        // bgimgObject.setControlVisible(tl,false)
        // bgimgObject.setControlsVisibility(mtr,false)
      });

      this["canvasObj" + index] = canvasObj;
      console.log(this["canvasObj" + index], "this[+index]");
    },
    canvasOnMouseDown(opt) {
      console.log("click", opt);
    },
    canvasItemAddImg(index, path, detailData) {
      let that = this;
      let canvasObj = this["canvasObj" + index];
      var maxWidth = 200; // 图片最大宽度限制
      var maxHeight = 100; // 图片最大高度限制
      console.log(
        Number(105 * Number(600 / that.customArr[0].naturalWidth)),
        "Number((image.width*(Number(that.customArr[0].naturalWidth/600))))"
      );
      let image = new Image();
      image.src = path;
      image.onload = () => {
        //1.创建图片实例对象
        let imgInstance = new fabric.Image(image, {
          left: detailData
            ? Number(detailData.dx / (that.customArr[0].naturalWidth / 600))
            : 0, // 图片相对画布的左侧距离
          top: detailData
            ? Number(detailData.dy / (that.customArr[0].naturalWidth / 600))
            : 0, // 图片相对画布的顶部距离
          opacity: 1, // 图片透明度
          // angle: 30,
          // 这里可以通过scaleX和scaleY来设置图片绘制后的大小，这里为原来大小的一半
          // scaleX: detailData?Number((detailData.ws*(image.width/200)).toFixed(2)):(maxWidth/image.width),
          // scaleY: detailData?Number((detailData.ws*(image.width/200)).toFixed(2)):(maxWidth/image.width),
          // scaleX: detailData?Number((detailData.ws*(600/that.customArr[0].naturalWidth)).toFixed(2)):Number(600/that.customArr[0].naturalWidth),
          // scaleY: detailData?Number((detailData.ws*(600/that.customArr[0].naturalWidth)).toFixed(2)):Number(600/that.customArr[0].naturalWidth),
          scaleX: detailData
            ? Number(detailData.ws)
            : Number(600 / that.customArr[0].naturalWidth),
          scaleY: detailData
            ? Number(detailData.ws)
            : Number(600 / that.customArr[0].naturalWidth),
          transparentCorners: false,
          cornerColor: "pink",
        });
        //实例对象的width和height可以获取图片的大小
        imgInstance.setControlsVisibility({
          ml: false,
          mb: false,
          mt: false,
          mr: false,
          mtr: false,
        });
        //2.添加到画布
        canvasObj.add(imgInstance);
        // let userObjectArr = that.userObjectArr
        // userObjectArr.push(imgInstance)
        // console.log(that.imgInstance,'imgInstanceimgInstance')
      };
      return;

      var bgimgObject1 = new fabric.Image.fromURL(path, function (oImg) {
        console.log(oImg, oImg.height, "oImgoImgoImg");
        // 在画布上添加图片
        canvasObj.add(oImg);
        // 调整图片大小和位置
        var maxWidth = 200; // 图片最大宽度限制
        var maxHeight = 100; // 图片最大高度限制

        var imgWidth = oImg.width; // 图片实际宽度
        var imgHeight = oImg.height; // 图片实际高度
        var rate = maxHeight / oImg.height;
        oImg.set({
          left: 0, // 图片相对画布的左侧距离
          top: 0, // 图片相对画布的顶部距离
          opacity: 1, // 图片透明度
          // angle: 30,
          // 这里可以通过scaleX和scaleY来设置图片绘制后的大小，这里为原来大小的一半
          scaleX: rate,
          scaleY: rate,
          transparentCorners: false,
          cornerColor: "pink",
        });
        canvasObj.renderAll();
        console.log(bgimgObject1, "bgimgObjectbgimgObject");
        oImg.setControlsVisibility({
          ml: false,
          mb: false,
          mt: false,
          mr: false,
          mtr: false,
        });
        // oImg.sendToBack()
      });
    },
    getImgInfo(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          let imageInfo = {
            width: img.width,
            height: img.height,
            naturalWidth: img.naturalWidth,
            naturalHeight: img.naturalHeight,
          };
          console.log(imageInfo, "imgimgimgimg");

          resolve(imageInfo);
        };
        img.src = url;
      });
    },
    handlevideoRemove() {
      this.formdata.video = "";
    },
    beforeCanvasItemUpload(file) {},
    beforePsdUpload(file) {
      console.log(file, "filefilefilefile", file.name.indexOf("psd"));
      const isLt5M = file.size / 1024 / 1024 < 5;
      // if (file.name.indexOf('psd') == -1) {
      //   this.$message.error("请上传正确的视频格式");
      //   return false;
      // }
      if (!isLt5M) {
        this.$message.error("上传视频大小不能超过5MB哦!");
        return false;
      }
      // this.handlePsdFile(file)
      this.loadingStatus = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor",
      });
    },
    handlePsdFile(file) {},
    beforevideoUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传视频大小不能超过5MB哦!");
        return false;
      }
      this.loadingStatus = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor",
      });
    },

    // 保存
    savegood(formName) {
      let params = {};
      let customArr = this.customArr;
      params.typeId = this.id;
      customArr.forEach((item, index) => {
        params.background = item.bgImg;
        params.poster = [];
        if (this["canvasObj" + index]) {
          let layers = this["canvasObj" + index].getObjects();
          console.log(layers, "layers", customArr);
          for (var i = 0; i < layers.length; i++) {
            if (i > 0) {
              var layer = layers[i];
              console.log("图层名称:", layer.name);
              let posterItem = {};
              posterItem.img = item.userImg[i - 1].imgUrl;
              (posterItem.dissolve = 100),
                // posterItem.w=item.naturalWidth,
                // posterItem.h=item.naturalHeight,
                (posterItem.dx = Math.ceil(
                  layers[i].left * (item.naturalWidth / item.width)
                )),
                (posterItem.dy = Math.ceil(
                  layers[i].top * (item.naturalWidth / item.width)
                )),
                // posterItem.ws=Number(((layers[i].scaleX)*(item.naturalWidth/item.width)).toFixed(2))
                // posterItem.ws=Number(((layers[i].scaleX)/(layers[i].width/200)).toFixed(2))
                // posterItem.ws=Number(((layers[i].scaleX)/(600/item.naturalWidth)).toFixed(2))
                (posterItem.ws = Number(layers[i].scaleX.toFixed(2)));
              (posterItem.w = layers[i].width),
                (posterItem.h = layers[i].height),
                (posterItem.w1 =
                  layers[i].width /
                  (item.width / item.naturalWidth / posterItem.ws));
              posterItem.wr = item.width / item.naturalWidth;
              params.poster.push(posterItem);
            }
          }
        }
      });
      console.log(params, "paramsparamsparams");
      if (this.lock) {
        this.lock = false;
        if (this.detailId) {
          this.submiteditsave(params);
          // if (this.goodsType === 2) {
          //   this.submitsave(params);
          // } else {
          //   this.submiteditsave(params);
          // }
        } else {
          this.submitsave(params);
        }
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {};
          if (this.lock) {
            this.lock = false;
            if (this.id) {
              if (this.goodsType === 2) {
                this.submitsave(params);
              } else {
                this.submiteditsave(params);
              }
            } else {
              this.submitsave(params);
            }
          }
        } else {
          return false;
        }
      });
    },
    // 是否设置支付信息
    ispayset() {
      let params = {};
      return this.axios.post(api.companyadmin_company_pay, params);
    },
    // 是否显示配置标签
    async ispaysetshow() {
      let res = await this.ispayset();
      if (res.data.code == 0) {
        this.ispayshow = res.data.info.is_set === 0 ? true : false;
      }
    },
    // 虚拟商品
    getvgoodparams() {
      let params = {
        type: this.formdata.type,
        goods_name: this.formdata.goods_name,
        cat_id: this.formdata.cat_id,
        album: this.formdata.album.join(","),
        video: this.formdata.video,
        goods_detail: this.formdata.goods_detail.join(","),
        order_desc: this.formdata.order_desc,
        is_sale: this.formdata.is_sale,
        is_hot: this.formdata.is_hot,
        is_recommend: this.formdata.is_recommend,
        is_cheap: this.formdata.is_cheap,
        is_new: this.formdata.is_new,
        goods_brief: this.formdata.goods_brief,
        goods_desc: this.formdata.goods_desc,
      };
      return params;
    },
    // 实体商品
    getgoodparams() {
      let params = {
        type: this.formdata.type,
        goods_name: this.formdata.goods_name,
        cat_id: this.formdata.cat_id,
        album: this.formdata.album.join(","),
        video: this.formdata.video,
        goods_detail: this.formdata.goods_detail.join(","),
        order_desc: this.formdata.order_desc,
        is_sale: this.formdata.is_sale,
        is_hot: this.formdata.is_hot,
        is_recommend: this.formdata.is_recommend,
        is_cheap: this.formdata.is_cheap,
        is_new: this.formdata.is_new,
        goods_brief: this.formdata.goods_brief,
        goods_desc: this.formdata.goods_desc,
        is_pay: this.formdata.is_pay,
      };
      // 仅线上展示
      if (this.formdata.is_pay === 1) {
        params.show_type = this.formdata.show_type;
        if (this.formdata.show_type === 0) {
          params.reference = this.formdata.reference1;
          params.reference_price = this.formdata.reference_price;
        } else {
          params.reference = this.formdata.reference2;
          params.reference_price = "";
        }
      }
      // 支持线上支付
      if (this.formdata.is_pay === 0) {
        params.is_attr = this.formdata.is_attr;
        params.unit = this.formdata.unit;
        params.false_sales = this.formdata.false_sales;

        // 单规格
        if (this.formdata.is_attr === 0) {
          params.cost = this.formdata.cost;
          params.shop_price = this.formdata.shop_price;
          params.show_price = this.formdata.show_price;
          params.goods_number = this.formdata.goods_number;
          params.points = this.formdata.points;
        }
        // 多规格
        if (this.formdata.is_attr === 1) {
          params.attr_cate = this.formdata.attr_cate;
          params.cost = this.formdata.cost;
          params.attr_data = this.getattrsetting();
        }

        // 提成
        params.comm_type = this.formdata.comm_type;
        params.commission = this.formdata.commission;

        // 分销
        params.comm_set = this.formdata.comm_set;

        if (this.formdata.comm_set === 1) {
          params.comm_outside = this.formdata.comm_outside;
          params.comm_inside = this.formdata.comm_inside;
        }
        // 物流
        params.logistics_set = this.formdata.logistics_set;
        if (this.formdata.logistics_set === 0) {
          params.shipping_set = this.formdata.shipping_set;
          if (this.formdata.shipping_set === 0) {
            params.shipping_fee = this.formdata.shipping_fee;
            params.fre_id = "";
          }
          if (this.formdata.shipping_set === 1) {
            params.fre_id = this.formdata.fre_id;
            params.shipping_fee = "";
          }
        }
        if (this.formdata.logistics_set === 1) {
          params.shipping_name = this.formdata.shipping_name === true ? 1 : 0;
          params.shipping_phone = this.formdata.shipping_phone === true ? 1 : 0;
        }
      }
      return params;
    },

    // 多规格设置数据参数
    getattrsetting() {
      let result = [];
      this.attremptycount = 0;
      if (this.attrtable && this.attrtable.length > 0) {
        this.attrtable.forEach((item) => {
          if (
            item.attr_price === "" ||
            item.attr_number === "" ||
            item.attr_number === ""
          ) {
            this.attremptycount++;
          }
          var setitem = {
            attr_price: item.attr_price,
            attr_number: item.attr_number,
            attr_points: item.attr_points,
          };
          setitem.attr_value = {};
          if (this.tablehead && this.tablehead.length) {
            this.tablehead.forEach((hitem) => {
              setitem.attr_value[item[hitem.label].spec_id] =
                item[hitem.label].id;
            });
          }
          result.push(setitem);
        });
      }
      return result;
    },
    // 提交保存
    submitsave(params) {
      this.axios
        .post(api.custom_add, params)
        .then((response) => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.goShowImg = response.data.data.pic;
            // this.goback();
          }
        })
        .catch((response) => {
          this.lock = true;
        });
    },
    // 提交保存
    submiteditsave(params) {
      console.log(params, "params1440=*=*=**==**=*=*=*=**==**==*=*");
      // goodsType 1 编辑 2 复制商品
      let message_ = "保存成功";
      // if (this.goodsType === 2) {
      //   message_ = "复制成功"
      // }
      params.id = this.detailId;
      this.axios
        .post(api.custom_edit, params)
        .then((response) => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: message_,
              type: "success",
            });
            this.goback();
          }
        })
        .catch((response) => {
          this.lock = true;
        });
    },
    goback() {
      this.$router.go(-1);
    },
    // 前往配置
    goset() {
      let routeData = this.$router.resolve({
        name: "payment",
      });
      window.open(routeData.href, "_blank");
    },
    // 前往运费模板
    createfreight() {
      let routeData = this.$router.resolve({
        name: "createFreight",
      });
      window.open(routeData.href, "_blank");
    },
    // 暂时注释，待接口调整后开启
    // 弹出表单列表
    // openFormList() {
    //   this.drawer = true;
    //   this.getFormData();
    // },
    // getFormData() {
    //   this.axios
    //     .post(api.companyadmin_form_list, {page: this.page.pageindex})
    //     .then(response => {
    //       if (response.data.code == 0) {
    //         this.formList = response.data.list;
    //         this.page.total = response.data.all_page;
    //       }
    //     })
    //     .catch(() => {});
    // },
    // selectForm(id, name) {
    //   this.form_id = id;
    //   this.form_name = name;
    // },
    // deleteForm() {
    //   this.form_id = "";
    //   this.form_name = "";
    // },
    // handleCurrentChange(val) {
    //   this.page.pageindex = val;
    //   this.getFormData();
    // },
    // handleClose() {
    //   this.drawer = false;
    // }
  },
};
</script>

<style scoped>
.outer_box {
  width: 200px;
  height: 200px;
}
.outer_box > div {
  white-space: nowrap;
  display: inline-block;
}
.outer_box > div > img {
  width: auto;
  height: auto;
  position: absolute;
}
.flex_wrap {
  -moz-user-select: none !important; /*火狐*/
  -webkit-user-select: none !important; /*webkit浏览器*/
  -ms-user-select: none !important; /*IE10*/
  -khtml-user-select: none !important; /*早期浏览器*/
  user-select: none !important;
}

canvas {
  border: 1px dashed black;
}
</style>
